<template>
    <div class="spinner">
      <div></div>
    </div>
</template>

<script>
export default {

}
</script>

<style scoped>
@-webkit-keyframes spin {
    0% {
      transform: rotate(0)
    }
    100% {
      transform: rotate(360deg)
    }
  }
  
  @-moz-keyframes spin {
    0% {
      -moz-transform: rotate(0)
    }
    100% {
      -moz-transform: rotate(360deg)
    }
  }
  
  @keyframes spin {
    0% {
      transform: rotate(0)
    }
    100% {
      transform: rotate(360deg)
    }
  }

.spinner {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1003;
  background: rgba(67, 114, 196, .2);
  overflow: hidden
}

.spinner div:first-child {
  display: block;
  position: relative;
  left: 50%;
  top: 50%;
  width: 150px;
  height: 150px;
  margin: -75px 0 0 -75px;
  border-radius: 50%;
  box-shadow: 0 7px 3px 0 rgba(247, 156, 17, 1);
  transform: translate3d(0, 0, 0);
  animation: spin 7s linear infinite
}

.spinner div:first-child:after,
.spinner div:first-child:before {
  content: '';
  position: absolute;
  border-radius: 50%
}

.spinner div:first-child:before {
  top: 7px;
  left: 7px;
  right: 7px;
  bottom: 7px;
  box-shadow: 0 7px 3px 0 rgba(180, 180, 190, 1);
  -webkit-animation: spin 3s linear infinite;
  animation: spin 6s linear infinite
}

.spinner div:first-child:after {
  top: 15px;
  left: 15px;
  right: 15px;
  bottom: 15px;
  box-shadow: 0 7px 3px 0 rgba(67, 114, 196, 1);
  animation: spin 5s linear infinite
}


/*.spinner {
  height: 150px;
  width: 150px;
  border: 3px solid transparent;
  border-radius: 50%;
  border-top: 4px solid #f15e41;
  -webkit-animation: spin 4s linear infinite;
  animation: spin 4s linear infinite;
  position: relative;
}

.spinner::before,
.spinner::after {
  content: "";
  position: absolute;
  top: 6px;
  bottom: 6px;
  left: 6px;
  right: 6px;
  border-radius: 50%;
  border: 4px solid transparent;
}

.spinner::before {
  border-top-color: #bad375;
  -webkit-animation: 3s spin linear infinite;
  animation: 3s spin linear infinite;
}

.spinner::after {
  border-top-color: #26a9e0;
  -webkit-animation: spin 1.5s linear infinite;
  animation: spin 1.5s linear infinite;
}   
             
@-webkit-keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
         transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}   
        
@keyframes spin {
    from {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        transform: rotate(360deg);
    }
}*/

</style>
